<template>
    <div id="checkout">
        <!-- Checkout will insert the payment form here -->
    </div>
    <div v-if="!stripeCheckout" class="loader"></div>
</template>

<script setup lang="ts">
import { stripeRef } from "#/utils/wmtools"
import { onMounted, ref, onBeforeUnmount } from "vue";
import { loadStripe } from '@stripe/stripe-js';

var clientSecret;

var stripeCheckout = ref<any>(null);

// function loadStripeJs() {
//     if (stripeRef.value) {
//         init()
//     } else {
//         loadJS(`https://js.stripe.com/v3/`, () => {
//             init()
//         });
//     }

// }

async function init() {
    if (!stripeRef.value) {
        let stripeKey = import.meta.env.VITE_STRIPE_KEY
        stripeRef.value = await loadStripe(stripeKey)
    }

    if (clientSecret) {
        stripeCheckout.value = await stripeRef.value.initEmbeddedCheckout({
            clientSecret,
        });

        console.log(stripeCheckout.value)

        // Mount Checkout
        stripeCheckout.value.mount('#checkout');
    }
}

onMounted(() => {
    if (history.state.stripeInfo) {
        clientSecret = history.state.stripeInfo.clientSecret
        init()
    }

})

onBeforeUnmount(() => {
    console.log('onBeforeUnmount---', stripeCheckout)
    if (stripeCheckout.value) {
        stripeCheckout.value.destroy()
    }
})


</script>

<style scoped>
.loader {
    border: 5px solid #f3f3f3;
    /* Light grey border */
    border-top: 5px solid #3498db;
    /* Blue border */
    border-radius: 50%;
    width: 40px;
    height: 40px;
    animation: spin 1s linear infinite;
    margin-bottom: 16px;
    position: absolute;
    left: 50%;
    top: 20%;
}

/* Animation for spinning effect */
@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>